import { EMAIL_REGEX } from '@/lib/constants';
import { normalizeEmail } from '@/lib/helpers/normalize-email';
import * as yup from 'yup';

export const normalizedEmailField = (requiredMessage = 'Email is required') =>
  yup
    .string()
    .required(requiredMessage)
    .transform((_value, originalValue) =>
      typeof originalValue === 'string'
        ? normalizeEmail(originalValue)
        : originalValue
    )
    .matches(EMAIL_REGEX, 'Please enter a valid email address');
